import { NATIVE_APP_IS_WEBVIEW } from "@tableyeti/webview-messages/src/constants/local-storage";
import VueDatePicker from "@vuepic/vue-datepicker";
import type { App } from "vue";
import api from "@/plugins/api";
import cookies from "@/plugins/cookie-consent";
import { i18n } from "@/plugins/i18n";
import intercom from "@/plugins/intercom";
import posthogPlugin from "@/plugins/posthog";
import vuetify from "@/plugins/vuetify";
import webviewSession from "@/plugins/webview-session";
import pinia from "@/store";
import "@vuepic/vue-datepicker/dist/main.css";

export function registerPlugins(app: App) {
  app.use(vuetify);
  app.use(i18n);
  app.use(pinia);
  app.use(posthogPlugin);
  app.use(api);

  const isWebview = localStorage.getItem(NATIVE_APP_IS_WEBVIEW);
  if (isWebview) {
    app.use(webviewSession);
    app.component("VueDatePicker", VueDatePicker);
  } else {
    app.component("VueDatePicker", VueDatePicker);
    app.use(intercom);
    app.use(cookies);
  }
}
